import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { NavbarComponent } from './navbar.component';
import { NavigationEnd, Router, RouterLink, RouterLinkActive } from '@angular/router';
import { Subscription } from 'rxjs';
import { PopupService } from '@mwe/services';
import { NgClass } from '@angular/common';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'mwe-navbar-footer',
  templateUrl: './navbar-footer.component.html',
  imports: [NgClass, RouterLink, TranslateDirective, RouterLinkActive, TranslatePipe],
})
export class NavbarFooterComponent extends NavbarComponent implements OnInit, OnDestroy {
  private popupService = inject(PopupService);
  private router = inject(Router);

  backdrop: HTMLElement;
  isProfileOpen = false;
  userName: string;
  emailAddress: string;
  private subscriptions = new Subscription();

  override async ngOnInit() {
    await super.ngOnInit();

    const routerSub = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd && window['drawCutOut']) {
        setTimeout(window['drawCutOut'], 10);
      }
    });
    this.subscriptions.add(routerSub);
    this.userName = this.accountLogic.getAccountFullName();
    this.emailAddress = this.accountLogic.getAccountEmail();
  }

  toggleProfile(): void {
    if (this.isProfileOpen) {
      this.closeProfile();
      return;
    }
    this.isProfileOpen = true;
    this.backdrop = document.createElement('div');
    this.backdrop.classList.add('modal-backdrop', 'fade', 'show');
    this.backdrop.style.zIndex = '1';
    this.backdrop.addEventListener('click', () => {
      this.closeProfile();
    });
    document.body.append(this.backdrop);
  }

  closeProfile(): void {
    this.isProfileOpen = false;
    this.backdrop?.remove();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  logout(): void {
    this.popupService.openLogoutPopup();
  }
}
